import { styled } from '@mui/material'
import { BEAMER_TRIGGER_ID } from '@omnea-app/fe-legacy/components/layout/wrapper/beamer'

// Beamer finds this by id to anchor its popup; its own badge is hidden, as the button draws ours.
const Anchor = styled('span')({
  position: 'absolute',
  top: 4,
  right: 6,
  width: 0,
  height: 0,
  pointerEvents: 'none',
  '& .beamer_icon': {
    display: 'none !important',
  },
})

/** Goes inside the button that opens product updates. */
export const BeamerTrigger = () => <Anchor id={BEAMER_TRIGGER_ID} />
